export default __webpack_public_path__ + "static/media/en.7be3d5a2.png";